import React from 'react'

import { CustomerInfo } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import styles from './requestPayment.module.scss'
import sessionResetDate from '../common/content/sessionResetDate'

const SessionsWarningModal = ({
  firstName,
  lastName,
  sessionsLeft,
  company,
  programDisplayName,
}: SessionsWarningModalProps) => {
  return (
    <div className={styles['modal-content']} data-test-id='RequestPayment-sessions-warning-modal'>
      <h2 className={styles['main-header']}>Thank you!</h2>
      <div>
        <p>
          Your payment was successfully submitted. As a reminder, <span className={styles.capitalize}>{firstName}</span>{' '}
          <span className={styles.capitalize}>{lastName}</span> has {sessionsLeft}{' '}
          {programDisplayName && `${programDisplayName} `}
          {sessionsLeft > 1 ? 'sessions' : 'session'} remaining where costs are covered by their Lyra benefit.{' '}
          {sessionResetDate({ employer: company?.label, date: company?.session_count_starts_on })}
        </p>
        <p className='paragraph-small'>
          We suggest that you and <span className={styles.capitalize}>{firstName}</span> start planning to complete
          treatment or begin discussing longer term care. Please note that once the session limit has been reached, Lyra
          is unable to reimburse for services. For any questions, please contact{' '}
          <a href='mailto:providers@lyrahealth.com'>providers@lyrahealth.com</a>
        </p>
      </div>
    </div>
  )
}

type SessionsWarningModalProps = {
  firstName: string
  lastName: string
  sessionsLeft: number
  company?: CustomerInfo
  programDisplayName?: string
}

export default SessionsWarningModal
